import { deleteCollector } from '@/api/collector';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { Label } from '@/components/ui/label';
import { Trash, Trash2Icon, TrashIcon } from 'lucide-react';
import toast from 'react-hot-toast';

type Props = {
  customer: Client | undefined;
};

const Call: React.FC<Props> = ({ customer }) => {
  const handleCall = () => {
    if (customer?.phone) {
      // Initiates a call by opening the dialer with the customer's phone number
      window.location.href = `tel:${customer.phone}`;
    } else {
      toast.error('Phone number is not available');
    }
  };

  return (
    <Dialog>
      <DialogTrigger className='bg-[#51D056] w-8 h-8  rounded-[10px] flex justify-center items-center hover:bg-[#51D056]/90 cursor-pointer hover:scale-[1.05] transition ease-in-out duration-200'>
        <img src='/assets/icons/phone.svg' alt='call' />
      </DialogTrigger>
      <DialogContent className='md:w-[40%] w-[90%] px-8 bg-white'>
        <DialogHeader>
          <DialogTitle className='text-base font-medium md:text-lg'>
            {' '}
            Call Customer
          </DialogTitle>

          <div className='space-y-3 '>
            <div className='flex text-sm gap-2 mt-4 text-muted-foreground'>
              Customer:
              <p className='text-black'>
                {customer?.commercial_name
                  ? customer.commercial_name
                  : 'commercial_name is not available'}{' '}
              </p>
            </div>
            <div className='flex text-sm gap-2  text-muted-foreground'>
              Phone:
              <p className='text-black'>
                {customer?.phone
                  ? customer.phone
                  : 'Phone number is not available'}{' '}
              </p>
            </div>
            <div className='flex text-sm gap-2 text-muted-foreground'>
              Email:
              <p className='text-black'>
                {customer?.email ? customer.email : 'Email is not available'}{' '}
              </p>
            </div>
          </div>

          <DialogFooter className='flex flex-row justify-center w-full space-x-4 '>
            <DialogClose className='mt-4' asChild>
              <Button
                className=' w-1/2  text-[#51D056] hover:bg-[#51D056]/20'
                variant='ghost'
                type='button'
              >
                Cancel
              </Button>
            </DialogClose>
            <Button
              className='rounded-[5px] mt-4 w-1/2 border-[#51D056] bg-[#51D056] text-white hover:bg-[#51D056]/90'
              type='button'
              onClick={handleCall}
            >
              Call
            </Button>
          </DialogFooter>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
};

export default Call;
